<template>
  <div class="d-flex align-items-center mb-4">
    <div
      class="text-muted"
      data-test="paginationInfo"
    >
      Viewing {{ currentItem }}-{{ lastItem }} of {{ listLength }} {{ itemText }}
    </div>
    <div class="flex-1"></div>
    <div
      class="d-flex align-items-center mb-0 paginate-links"
      :class="buttonsClass"
    >
      <AppButton
        class="mr-3"
        data-test="pagination-btn-prev"
        :disabled="currentPage === 1 || isLoading"
        @click="updatePagination('previous')"
      >
        <AppIcon name="keyboard_arrow_left" />
        Previous
      </AppButton>
      <AppButton
        class="ml-3"
        data-test="pagination-btn-next"
        :disabled="currentPage >= totalPages || isLoading"
        @click="updatePagination('next')"
      >
        <span>Next</span>
        <AppIcon name="keyboard_arrow_right" />
      </AppButton>
    </div>
  </div>
</template>

<script>
import { LIMIT_MEDIUM } from '@shared/constants/pagination'

export default {
  props: {
    currentPage: {
      default: 1,
      type: Number,
    },
    per: {
      default: 25,
      type: Number,
    },
    listLength: {
      default: 100,
      type: Number,
    },
    itemText: {
      default: '',
      type: String,
    },
    buttonsClass: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      skip: 0,
      limit: LIMIT_MEDIUM,
    }
  },
  computed: {
    totalPages () {
      const listLength = parseInt(this.listLength) * 1.0
      const per = parseInt(this.per)
      return Math.ceil(listLength / per) || 1
    },
    currentItem () {
      if (!this.lastItem) return 0
      return (this.currentPage * this.per) - this.per + 1
    },
    lastItem () {
      const number = this.currentPage * this.per
      if (number > this.listLength) return this.listLength
      return number
    },
  },
  methods: {
    updatePagination (direction) {
      const fromPage = this.currentPage
      let toPage
      if (direction === 'previous') {
        if (fromPage === 1) return
        toPage = this.currentPage - 1
      }
      if (direction === 'next') {
        if (fromPage === this.totalPages) return
        toPage = this.currentPage + 1
      }
      this.$emit('updatePagination', { toPage, fromPage })
    },
  },
}
</script>
<style scoped>
.btn[disabled] {
  color: var(--text-muted) !important;
  opacity: 0.65;
}
</style>
